module.exports = __webpack_public_path__ + "img/la.9f63ddf4.svg";